import WeatherAPI from "./weather"

// exports Weather API
export default () => new WeatherAPI()